import { RecipientType, zo } from 'remote/global';

const messageGroupSchema = zo.object({
  name: zo.string().min(1).max(64),
  description: zo.string().max(128).optional(),
  id: zo.number().optional(),
  operatorId: zo.number().optional(),
});

type MessageGroupSchemaType = zo.infer<typeof messageGroupSchema>;

const memberListSchema = zo.object({
  members: zo.array(zo.number()).refine((data) => data.length > 0),
});
type MemberListSchemaType = zo.infer<typeof memberListSchema>;

const newMessageGroupSchema = zo.intersection(messageGroupSchema, memberListSchema);

const newMessageSchema = zo
  .object({
    recipientType: zo.nativeEnum(RecipientType),
    recipient: zo.number().optional(),
    subject: zo.string().min(1).max(64),
    content: zo.string().min(1).max(128),
  })
  .refine(
    (data) => {
      if (data.recipientType !== RecipientType.ALL) {
        // Make recipient required when recipientType is not of RecipientType.ALL
        if (data.recipient == null || data.recipient === 0) return false;
      }
      return true;
    },
    { params: { i18n: 'required' }, path: ['recipient'] }
  );

const userMessageDtoSchema = zo.object({
  content: zo.string(),
  createdAt: zo.string().datetime().optional(),
  groupId: zo.string().optional(),
  groupName: zo.string().optional(),
  id: zo.number().optional(),
  recipientType: zo.nativeEnum(RecipientType),
  seenAt: zo.string().datetime().optional(),
  seenCount: zo.number().optional(),
  senderId: zo.number().optional(),
  senderName: zo.string().optional(),
  subject: zo.string(),
  totalCount: zo.number().optional(),
  userFullName: zo.string().optional(),
  userId: zo.number().optional(),
});

type NewMessageSchemaType = zo.infer<typeof newMessageSchema>;
type NewMessageGroupSchemaType = zo.infer<typeof newMessageGroupSchema>;
type UserMessageDtoSchemaType = zo.infer<typeof userMessageDtoSchema>;

export {
  newMessageGroupSchema,
  memberListSchema,
  newMessageSchema,
  userMessageDtoSchema,
  messageGroupSchema,
};
export type {
  NewMessageGroupSchemaType,
  MemberListSchemaType,
  NewMessageSchemaType,
  UserMessageDtoSchemaType,
  MessageGroupSchemaType,
};
